import { GridApplicationCommentsService } from 'src/app/+grid-application-shared/services/grid-application-comments.service';
import { UrlSegments } from 'src/app/jurisdiction/jurisdiction.constants';
import { CommunicationService } from 'src/app/services/communication.service';
import { GridCompTechnicalSpecificationsSectionsState } from '../entities/sections-state/gridCompTechnicalSpecificationsSectionsState';
import { Observable } from 'rxjs';
import { PersonalDataSectionsState } from 'src/app/+grid-application-shared/entities/sections-state/personalDataSectionsState';
import { DocumentsSectionsState } from 'src/app/+grid-application-shared/entities/sections-state/documentsSectionsState';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GridCompatibilityCommentsService extends GridApplicationCommentsService {
  constructor(private readonly communicationService: CommunicationService) {
    super();
  }

  public createTechnicalSpecificationsSectionComment(updateRequest: GridCompTechnicalSpecificationsSectionsState): Observable<any> {
    return this.communicationService.postData(UrlSegments.GridCompTechnicalSpecificationsSectionComment, updateRequest);
  }

  public updateTechnicalSpecificationsSectionComment(updateRequest: GridCompTechnicalSpecificationsSectionsState): Observable<any> {
    return this.communicationService.updateData(UrlSegments.GridCompTechnicalSpecificationsSectionComment, updateRequest);
  }

  public createPersonalDataSectionComment(updateRequest: PersonalDataSectionsState): Observable<any> {
    return this.communicationService.postData(UrlSegments.GridCompPersonalDataSectionComment, updateRequest);
  }

  public updatePersonalDataSectionComment(updateRequest: PersonalDataSectionsState): Observable<any> {
    return this.communicationService.updateData(UrlSegments.GridCompPersonalDataSectionComment, updateRequest);
  }

  public createDocumentsSectionComment(updateRequest: DocumentsSectionsState): Observable<any> {
    return this.communicationService.postData(UrlSegments.GridCompDocumentsSectionComment, updateRequest);
  }

  public updateDocumentsSectionComment(updateRequest: DocumentsSectionsState): Observable<any> {
    return this.communicationService.updateData(UrlSegments.GridCompDocumentsSectionComment, updateRequest);
  }
}
